// extracted by mini-css-extract-plugin
module.exports = {"icon":"TitleIconList_icon__DWE1o","list":"TitleIconList_list__3OXms"};